(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Raphael"));
	else if(typeof define === 'function' && define.amd)
		define(["Raphael"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("Raphael")) : factory(root["Raphael"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_15__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/